/**
 * Mobile PDP: peek-swipe counter on gallery.
 * Lightbox: full-image fit, pinch/double-tap zoom + pan, swipe between slides at 1x.
 */
(function () {
  var MAX_SCALE = 4;
  var MIN_SCALE = 1;
  var DOUBLE_TAP_MS = 280;

  function ensureCount(wrapper, total, className) {
    var el = wrapper.querySelector("." + className);
    if (!el) {
      el = document.createElement("div");
      el.className = className;
      el.setAttribute("aria-hidden", "true");
      wrapper.appendChild(el);
    }
    el.hidden = total < 2;
    return el;
  }

  function activeIndexFromScroll(scroller, items) {
    if (!items.length) return 0;
    var left = scroller.scrollLeft;
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(items[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    }
    return best;
  }

  function bindGallery(gallery) {
    if (gallery.dataset.ztGalleryBound === "1") return;
    gallery.dataset.ztGalleryBound = "1";

    var list = gallery.querySelector(".product__media-list");
    var wrapper =
      gallery.closest(".product__media-wrapper") ||
      gallery.parentElement ||
      gallery;
    if (!list) return;

    var items = list.querySelectorAll(".product__media-item");
    var total = items.length;
    var countEl = ensureCount(wrapper, total, "zt-gallery-count");
    if (total < 2) return;

    function paint() {
      countEl.textContent = activeIndexFromScroll(list, items) + 1 + " / " + total;
    }

    paint();
    list.addEventListener("scroll", paint, { passive: true });
    window.addEventListener("resize", paint, { passive: true });
  }

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function distance(a, b) {
    var dx = a.clientX - b.clientX;
    var dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function midpoint(a, b) {
    return {
      x: (a.clientX + b.clientX) / 2,
      y: (a.clientY + b.clientY) / 2,
    };
  }

  function wrapSlides(content) {
    if (content.dataset.ztWrapped === "1") return;
    var kids = Array.prototype.slice.call(content.children);
    kids.forEach(function (el) {
      if (el.nodeType !== 1 || el.tagName === "TEMPLATE") return;
      if (el.classList.contains("zt-lightbox-slide")) return;
      var slide = document.createElement("div");
      slide.className = "zt-lightbox-slide";
      if (el.classList.contains("active")) slide.classList.add("active");
      if (el.hasAttribute("data-media-id")) {
        slide.setAttribute("data-media-id", el.getAttribute("data-media-id"));
      }
      // Move Dawn's active class onto the slide shell.
      el.classList.remove("active");
      content.insertBefore(slide, el);
      slide.appendChild(el);

      var img = el.tagName === "IMG" ? el : el.querySelector("img");
      if (img) {
        img.classList.add("zt-lightbox-img");
        // Request a sharp source so pinch-zoom stays crisp.
        img.setAttribute("sizes", "200vw");
        img.draggable = false;
      }
    });
    content.dataset.ztWrapped = "1";
  }

  function bindModal(modal) {
    if (modal.dataset.ztModalBound === "1") return;
    modal.dataset.ztModalBound = "1";

    var content = modal.querySelector(".product-media-modal__content");
    if (!content) return;

    var countEl = ensureCount(modal, 2, "zt-modal-count");
    var scale = 1;
    var tx = 0;
    var ty = 0;
    var activeImg = null;
    var pinchStartDist = 0;
    var pinchStartScale = 1;
    var panStartX = 0;
    var panStartY = 0;
    var panOriginTx = 0;
    var panOriginTy = 0;
    var lastTapAt = 0;
    var lastTapX = 0;
    var lastTapY = 0;
    var gesturing = false;

    function slideItems() {
      return Array.prototype.filter.call(content.children, function (el) {
        return el.classList && el.classList.contains("zt-lightbox-slide");
      });
    }

    function currentSlide() {
      var items = slideItems();
      if (!items.length) return null;
      return items[activeIndexFromScroll(content, items)] || items[0];
    }

    function imgIn(slide) {
      if (!slide) return null;
      return slide.querySelector(".zt-lightbox-img") || slide.querySelector("img");
    }

    function applyTransform() {
      if (!activeImg) return;
      activeImg.style.transform =
        "translate3d(" + tx + "px," + ty + "px,0) scale(" + scale + ")";
      var zoomed = scale > 1.01;
      content.classList.toggle("is-zoomed", zoomed);
      modal.classList.toggle("is-zoomed", zoomed);
      if (zoomed) {
        content.style.overflowX = "hidden";
      } else {
        content.style.overflowX = "";
        tx = 0;
        ty = 0;
        activeImg.style.transform = "translate3d(0,0,0) scale(1)";
      }
    }

    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      if (activeImg) {
        activeImg.style.transform = "";
      }
      content.classList.remove("is-zoomed");
      modal.classList.remove("is-zoomed");
      content.style.overflowX = "";
    }

    function setActiveFromScroll() {
      var slide = currentSlide();
      var nextImg = imgIn(slide);
      if (nextImg !== activeImg) {
        if (activeImg) activeImg.style.transform = "";
        activeImg = nextImg;
        scale = 1;
        tx = 0;
        ty = 0;
        content.classList.remove("is-zoomed");
        modal.classList.remove("is-zoomed");
        content.style.overflowX = "";
      }
    }

    function paint() {
      var items = slideItems();
      var total = items.length;
      if (total < 2) {
        countEl.hidden = true;
        return;
      }
      countEl.hidden = false;
      countEl.textContent = activeIndexFromScroll(content, items) + 1 + " / " + total;
    }

    function scrollActiveIntoView() {
      wrapSlides(content);
      var items = slideItems();
      var active =
        content.querySelector(".zt-lightbox-slide.active") ||
        content.querySelector("[data-media-id].active") ||
        items[0];
      // Prefer the media Dawn marked active (may still be on img before wrap sync).
      var dawnActive = content.querySelector("img.active, [data-media-id].active");
      if (dawnActive) {
        var shell = dawnActive.closest(".zt-lightbox-slide");
        if (shell) active = shell;
      }
      if (!active) return;
      items.forEach(function (s) {
        s.classList.toggle("active", s === active);
      });
      content.scrollLeft = active.offsetLeft;
      setActiveFromScroll();
      paint();
    }

    function clampPan() {
      if (!activeImg || scale <= 1) {
        tx = 0;
        ty = 0;
        return;
      }
      var layoutW = activeImg.offsetWidth * scale;
      var layoutH = activeImg.offsetHeight * scale;
      var maxX = Math.max(0, (layoutW - window.innerWidth) / 2 + 16);
      var maxY = Math.max(0, (layoutH - window.innerHeight) / 2 + 16);
      tx = clamp(tx, -maxX, maxX);
      ty = clamp(ty, -maxY, maxY);
    }

    function zoomTo(nextScale, cx, cy) {
      if (!activeImg) return;
      var prev = scale || 1;
      scale = clamp(nextScale, MIN_SCALE, MAX_SCALE);
      if (scale <= 1.01) {
        resetZoom();
        return;
      }
      var ratio = scale / prev;
      tx = cx - window.innerWidth / 2 - (cx - window.innerWidth / 2 - tx) * ratio;
      ty = cy - window.innerHeight / 2 - (cy - window.innerHeight / 2 - ty) * ratio;
      clampPan();
      applyTransform();
    }

    content.addEventListener(
      "scroll",
      function () {
        if (scale > 1.01) return;
        setActiveFromScroll();
        paint();
      },
      { passive: true }
    );

    content.addEventListener(
      "touchstart",
      function (e) {
        setActiveFromScroll();
        if (!activeImg) return;

        if (e.touches.length === 2) {
          gesturing = true;
          pinchStartDist = distance(e.touches[0], e.touches[1]);
          pinchStartScale = scale;
          e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01) {
          gesturing = true;
          panStartX = e.touches[0].clientX;
          panStartY = e.touches[0].clientY;
          panOriginTx = tx;
          panOriginTy = ty;
        }
      },
      { passive: false }
    );

    content.addEventListener(
      "touchmove",
      function (e) {
        if (!activeImg) return;

        if (e.touches.length === 2 && pinchStartDist) {
          var dist = distance(e.touches[0], e.touches[1]);
          var mid = midpoint(e.touches[0], e.touches[1]);
          var next = (pinchStartScale * dist) / pinchStartDist;
          // Recompute from pinch start each move for stability
          var prevScale = scale;
          scale = clamp(next, MIN_SCALE, MAX_SCALE);
          if (prevScale !== scale) {
            var ratio = scale / (prevScale || 1);
            tx = mid.x - window.innerWidth / 2 - (mid.x - window.innerWidth / 2 - tx) * ratio;
            ty = mid.y - window.innerHeight / 2 - (mid.y - window.innerHeight / 2 - ty) * ratio;
          }
          if (scale <= 1.01) {
            resetZoom();
          } else {
            clampPan();
            applyTransform();
          }
          e.preventDefault();
          return;
        }

        if (e.touches.length === 1 && scale > 1.01 && gesturing) {
          tx = panOriginTx + (e.touches[0].clientX - panStartX);
          ty = panOriginTy + (e.touches[0].clientY - panStartY);
          clampPan();
          applyTransform();
          e.preventDefault();
        }
      },
      { passive: false }
    );

    content.addEventListener(
      "touchend",
      function (e) {
        if (e.touches.length < 2) pinchStartDist = 0;

        if (e.touches.length === 0) {
          // Double-tap zoom toggle
          if (!gesturing || scale <= 1.01) {
            var t = e.changedTouches[0];
            var now = Date.now();
            var dt = now - lastTapAt;
            var dx = Math.abs(t.clientX - lastTapX);
            var dy = Math.abs(t.clientY - lastTapY);
            if (dt < DOUBLE_TAP_MS && dx < 24 && dy < 24) {
              setActiveFromScroll();
              if (scale > 1.01) {
                resetZoom();
              } else {
                scale = 1;
                tx = 0;
                ty = 0;
                zoomTo(2.4, t.clientX, t.clientY);
              }
              lastTapAt = 0;
              e.preventDefault();
            } else {
              lastTapAt = now;
              lastTapX = t.clientX;
              lastTapY = t.clientY;
            }
          }
          gesturing = false;
          if (scale <= 1.01) resetZoom();
        }
      },
      { passive: false }
    );

    // Desktop: click toggles mild zoom; wheel zooms.
    content.addEventListener("dblclick", function (e) {
      if (window.matchMedia("(max-width: 749px)").matches) return;
      setActiveFromScroll();
      if (!activeImg) return;
      if (scale > 1.01) {
        resetZoom();
      } else {
        zoomTo(2.2, e.clientX, e.clientY);
      }
    });

    var observer = new MutationObserver(function () {
      if (modal.hasAttribute("open")) {
        resetZoom();
        window.requestAnimationFrame(scrollActiveIntoView);
        window.setTimeout(scrollActiveIntoView, 50);
      } else {
        resetZoom();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ["open"] });

    if (modal.hasAttribute("open")) {
      scrollActiveIntoView();
    }
  }

  function boot() {
    document.querySelectorAll("media-gallery").forEach(bindGallery);
    document.querySelectorAll("product-modal").forEach(bindModal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
